
import { AlertCircle, CheckCircle2, Clock, Info } from "lucide-react";
import { ReactNode } from "react";

export interface WebhookEvent {
  id: string;
  created_at: string;
  event_type: string;
  phone_number: string;
  verified: boolean;
  content?: string;
  request_body?: any;
  status?: string;
}

export const getEventIcon = (eventType: string): ReactNode => {
  if (!eventType) return <Info className="h-4 w-4 text-gray-400" />;
  if (eventType.includes("received")) return <CheckCircle2 className="h-4 w-4 text-green-500" />;
  if (eventType.includes("failed") || eventType.includes("offline")) return <AlertCircle className="h-4 w-4 text-red-500" />;
  if (eventType.includes("sent")) return <Clock className="h-4 w-4 text-blue-500" />;
  if (eventType.includes("delivered")) return <CheckCircle2 className="h-4 w-4 text-blue-500" />;
  return <Info className="h-4 w-4 text-amber-500" />;
};

export const getEventColor = (eventType: string): string => {
  if (!eventType) return "gray";
  if (eventType.includes("received")) return "green";
  if (eventType.includes("failed") || eventType.includes("offline")) return "red";
  if (eventType.includes("sent")) return "blue";
  if (eventType.includes("delivered")) return "blue";
  return "yellow";
};
